module.exports = __webpack_public_path__ + "static/img/home_process_accredit_3.b35510b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/official/home_process_accredit_3.png
// module id = GoUp
// module chunks = 1